export const COLUMN_ID_ACTIONS = "mb-col-id-actions";
export const COLUMN_ID_AUTO_GROUP = "mb-col-id-auto-group";
export const COLUMN_ID_AUTO_COLUMN = "ag-Grid-AutoColumn";

export const ROW_ID_PAGINATION = "mb-row-id-pagination";
export const ROW_ID_TOTAL = "mb-row-id-total";
